module.exports = __webpack_public_path__ + "static/media/tomatoes-default-user-image.7d10f108.png";